import { render } from "./RepTitleDialog.vue?vue&type=template&id=70953a63"
import script from "./RepTitleDialog.vue?vue&type=script&lang=js"
export * from "./RepTitleDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__